export default __webpack_public_path__ + "static/placeholder-78388717cf813f6e73f6aed19243072b.png";